import { render, staticRenderFns } from "./AdditionalElevator.vue?vue&type=template&id=0da2d56a&scoped=true"
import script from "./AdditionalElevator.vue?vue&type=script&lang=js"
export * from "./AdditionalElevator.vue?vue&type=script&lang=js"
import style0 from "./AdditionalElevator.vue?vue&type=style&index=0&id=0da2d56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2d56a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VTreeview})
